import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import TagManager from 'react-gtm-module'

const googleTagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

const tagManagerArgs = {
    gtmId: googleTagManagerId
}

TagManager.initialize(tagManagerArgs)


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
